import React, { useCallback, useEffect, useState } from 'react';
import { api, API_ROUTERS } from '../../../services/api';
import Store, { useAppDispatch } from '../../../store';
import { Empresa } from '../../Cadastros/Empresas/types';
import { hojeLocal } from './saude';
import SaudeIntegracaoView from './view';

/**
 * Relatorio de saude da integracao ERP -> Entregas.
 *
 * Le a MESMA lista de /api/empresa do cadastro -- url, token e
 * ultima_sincronizacao ja vem de la, entao o relatorio nao precisa de rota
 * propria nem de consulta extra no banco.
 */
const SaudeIntegracaoContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const [empresas, setEmpresas] = useState<Empresa[]>([]);
  const [erro, setErro] = useState('');
  const hoje = hojeLocal();

  const carregar = useCallback(async () => {
    try {
      setErro('');
      Store.load.show(dispatch, 'Consultando integrações');
      const lista = api.utils.trataResponseArray(
        await api.get(API_ROUTERS.EMPRESA)
      ) as Empresa[];
      setEmpresas(lista);
    } catch (err) {
      console.error('Erro ao carregar integrações:', err);
      setErro(
        'Não foi possível carregar a situação das integrações. Tente novamente.'
      );
    } finally {
      Store.load.hide(dispatch);
    }
  }, [dispatch]);

  useEffect(() => {
    carregar();
  }, [carregar]);

  return <SaudeIntegracaoView empresas={empresas} erro={erro} hoje={hoje} />;
};

export default SaudeIntegracaoContainer;
